import { Component, EventEmitter, Output } from '@angular/core';
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';


import {
  DocumentVersionUpdateFormAbstractComponent
} from '../../../form/documento/document-version-update-form-abstract.component';
import { DocumentoAllegato } from '../../../models/documento-allegato';


declare var closeModal: any;

@Component({
  selector: '[doc_version_update_form]',
  templateUrl: '../../../form/documento/document-version-update-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class DocumentVersionUpdateFormComponent extends DocumentVersionUpdateFormAbstractComponent {

  @Output()
  onReturn  = new EventEmitter();
  private refDocumentale: string;

  buildForm(documento: DocumentoAllegato) {
    this.refDocumentale = documento.refDocumentale;
    this.createForm(documento);
  }

  getUrlUploadNewVersionDocumento() {
    return ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_UPLOAD_NEW_VERSION_DOCUMENTO;
  }

  getUrlUploadNewVersionDocumentoMissingFile() {
    return ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_UPLOAD_NEW_VERSION_DOCUMENTO_MISSING_FILE;
  }

  getRefDocumentale() {
    return this.refDocumentale;
  }
}
